export default __webpack_public_path__ + "static/media/roadmap-d-6.86556ad7.png";